module.exports = __webpack_public_path__ + "img/ImageIcon.ef376f3c.svg";